/**
 * NotFound — 404. Added 2026-09-05 (F36).
 *
 * The catch-all used to render <LandingRedirect />, which sent an authenticated
 * user to their workspace home. A mistyped URL, a stale bookmark and a genuinely
 * broken in-app link were therefore all indistinguishable from "you asked for
 * the app" — the redirect swallowed the evidence. A dead link inside the product
 * could survive indefinitely because it always LOOKED like it worked.
 *
 * The path is shown back to the reader so a support message can quote it.
 */
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/auth";
import { homeFor } from "@/lib/routes";

export function NotFound() {
  const { pathname } = useLocation();
  const { user, profile } = useAuth();
  const home = user ? homeFor(profile?.role) : "/";

  return (
    <main
      style={{
        minHeight: "100dvh",
        display: "grid",
        placeItems: "center",
        padding: 24,
        textAlign: "center",
      }}
    >
      <div style={{ maxWidth: 460 }}>
        <div
          style={{
            fontFamily: "var(--mono)",
            fontSize: 11,
            letterSpacing: ".14em",
            textTransform: "uppercase",
            color: "var(--ink-light)",
          }}
        >
          404
        </div>
        <h1 style={{ fontSize: 22, margin: "10px 0 8px" }}>
          That page doesn&rsquo;t exist
        </h1>
        <p className="muted" style={{ fontSize: 14, lineHeight: 1.55 }}>
          Nothing is served at{" "}
          <code
            style={{
              fontFamily: "var(--mono)",
              fontSize: 12.5,
              wordBreak: "break-all",
            }}
          >
            {pathname}
          </code>
          . If you followed a link from inside StockSense, that link is broken —
          quoting this address to support is the fastest way to get it fixed.
        </p>
        <div
          style={{
            marginTop: 20,
            display: "flex",
            gap: 10,
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          <Link className="btn primary" to={home} style={{ minHeight: 44 }}>
            {user ? "Back to my workspace" : "Go to StockSense"}
          </Link>
          <a
            className="btn"
            href="https://wa.me/917757025257"
            target="_blank"
            rel="noopener noreferrer"
            style={{ minHeight: 44 }}
          >
            Contact support
          </a>
        </div>
      </div>
    </main>
  );
}
